
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.108 20c1.061 0 2.127-.224 3.197-.673 1.07-.449 1.969-1.049 2.695-1.8l-.866-1.73c-.763.732-1.568 1.296-2.415 1.69-.847.393-1.699.59-2.555.59-1.713 0-2.992-.673-3.84-2.02-.483-.768-.83-1.76-1.037-2.975l-.03-.197h4.907v-1.621H5.089l-.009-.171c-.009-.18-.015-.363-.02-.55l-.006-.57c0-.382.009-.75.026-1.106l.01-.158h5.074V7.06h-4.9l.026-.16c.184-1.052.474-1.939.872-2.66l.177-.298c.856-1.346 2.131-2.019 3.825-2.019.856 0 1.708.197 2.555.59.847.395 1.652.958 2.415 1.69L16 2.473A7.705 7.705 0 0013.333.632 8.326 8.326 0 0010.108 0C8.563 0 7.237.394 6.13 1.181c-1.107.788-1.95 1.923-2.527 3.407a11.78 11.78 0 00-.598 2.162l-.051.31H0V8.71h2.773l-.026.573-.01.69c0 .237.003.469.01.697l.028.595H0v1.62h2.95l.054.337c.107.591.245 1.147.416 1.668l.182.51c.577 1.492 1.42 2.632 2.527 3.42C7.237 19.606 8.563 20 10.11 20z","fill":"#fff"}})])
          )
        }
      }
    